import Navbar from "./component/Navbar/Navbar";
import "./App.css";
import Footer from "./component/Footer/Footer";
import Home from "./Pages/Home/Home";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ApprovedSocieties from "./Pages/Approved Societies/ApprovedSocieties";
import UnauthorizedSocieties from "./Pages/Unauthorized-Societies/Unauthorized-Societies";
import UnapprovedSocieties from "./Pages/Unapproved Societies/UnapprovedSocieties";
import NotFound from "./component/Not Found/NotFound";
import AboutUs from "./Pages/About us/AboutUs";
import AboutRDA from "./Pages/About RDA/AboutRDA";
import AboutRawalpindi from "./Pages/About rawalpindi/AboutRawalpindi";
import AboutAuthority from "./Pages/About authority/AboutAuthority";
import Directorates from "./Pages/Directorates/Directorates";
import AboutManagement from "./component/About Management/AboutManagement";
import Projects from "./Pages/Projects/Projects";
import ContactUs from "./Pages/Contact Us/ContactUs";
import Media from "./Pages/Media/Media";
import PressReleases from "./Pages/Press Releases/PressReleases";
import Tenders from "./Pages/Tenders/Tenders";
import Careers from "./Pages/Careers/Careers";
import Blog from "./Pages/Blog/Blog";
import PrivateSocieties from "./component/Private Societies/PrivateSocieties";
import { useEffect, useState } from "react";
import MainLoader from "./component/Loader/MainLoader";
import PublicNotices from "./Pages/Public Notices/PublicNotices";
import Downloads from "./Pages/Downloads/Downloads";
import ScrollToTop from "./utilis/ScrollTop";
import ComingSoon from "./Pages/Coming Soon/ComingSoon";
import Organogram from "./Pages/Organogram/Organogram";
import PopUp from "./component/Pop Up/PopUp";
import BlogPage from "./Pages/BlogPage/BlogPage";
import ProjectDetails from "./Pages/Project Details/ProjectDetails";
import BuildingPlans from "./Pages/Building Plans/BuildingPlans";
import {
  directoratesData,
  directoratesPage,
} from "./component/Directorates/DirectoratesData";
import Directorate from "./component/Directorates/Directorate";
import { ToastContainer } from "react-toastify";
import SideCTA from "./component/Navbar/SideCTA";
import Analytics from "./utilis/Analytics";
import LatestNews from "./Pages/Latest News/LatestNews";
import Maintanance from "./Pages/Maintanance/Maintanance";
// import Administration from "./component/Directorates/Administration Directorate";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

const isMaintenanceMode =
  process.env.REACT_APP_IS_MAINTENANCE_MODE === "true";
  if (isMaintenanceMode) {
    return <Maintanance />;
  }

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        progressClassName="toastProgress"
        className={"custom-toast-container"}
      />
      {isLoading ? (
        <div className="w-full">
          <MainLoader />
        </div>
      ) : (
        <div className="bg-[#F6F6F6] w-full min-h-screen ">
          <BrowserRouter>
           <Analytics />
            <ScrollToTop />
            <PopUp />
            <div className="fixed z-40 md:bottom-14 md:right-6 bottom-4 right-4">
              <SideCTA />
            </div>
            <Navbar />
            <div className=" overflow-hidden">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/*" element={<ComingSoon />} />

                <Route path="/about-us" element={<AboutUs />} />
                <Route path="/project-2" element={<Projects />} />
                <Route path="/project/:id" element={<ProjectDetails />} />
                <Route path="/directorates-2" element={<Directorates />} />
                <Route path="/building-plans" element={<BuildingPlans />} />
                <Route
                  path="/private-housing-schemes"
                  element={<PrivateSocieties />}
                />
                {directoratesPage?.map((directorate) => (
                  <Route
                    key={directorate.route}
                    path={directorate.route}
                    element={
                      <Directorate data={directoratesData[directorate?.name]} />
                    }
                  />
                ))}

                <Route path="/public-notices" element={<PublicNotices />} />
                <Route path="/about-rda" element={<AboutRDA />} />
                <Route path="/rawalpindi" element={<AboutRawalpindi />} />
                <Route path="/authority" element={<AboutAuthority />} />
                <Route path="/management" element={<AboutManagement />} />
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="/press-release" element={<PressReleases />} />
                <Route path="/tenders" element={<Tenders />} />
                <Route path="/careers" element={<Careers />} />
                <Route path="/downloads" element={<Downloads />} />
                <Route path="/blogs" element={<Blog />} />
                <Route path="/blog/:id" element={<BlogPage />} />
                <Route path="/media" element={<Media />} />
                <Route path="*" element={<NotFound />} />

                <Route path="/ahs" element={<ApprovedSocieties />} />
                <Route path="/uhs" element={<UnapprovedSocieties />} />
                <Route path="/ihs" element={<UnauthorizedSocieties />} />
                <Route path="/organogram" element={<Organogram />} />
                <Route path="/latest-news" element={<LatestNews />} />
              </Routes>
            </div>

            <Footer />
          </BrowserRouter>
        </div>
      )}
    </>
  );
}

export default App;
